import { MarketingPreferencesFormConfig } from '../../models/marketing-preferences/marketing-preferences-form-config.interface';
import { mockCmsMarketingPreferencesForm } from '../cms/cms-marketing-preferences-form.mock';
import { mockMarketingPreferencesFormValue } from './marketing-preferences-form-value.mock';

export const mockMarketingPreferencesFormConfig: MarketingPreferencesFormConfig =
  {
    cmsData: mockCmsMarketingPreferencesForm,
    initialValue: mockMarketingPreferencesFormValue,
  };
